import { Input } from '@evaneos/b2b-ui/legacy';
import { useField } from 'formik';
import { useIntl } from 'react-intl';

import { AllTranslationKeys } from '../../../../../shared/intl/types';

type Props = {
    name: string;
    label?: string;
    wrapperClassName?: string;
};

export const TextFormInput = ({ ...props }: Props): JSX.Element => {
    const [field, meta] = useField(props.name);
    const intl = useIntl();

    return (
        <Input
            {...field}
            {...props}
            type="text"
            errorText={
                meta.error &&
                intl.formatMessage({
                    id: meta.error as AllTranslationKeys,
                })
            }
            error={!!meta.error && meta.touched}
            style={{ width: '100%' }}
            data-testid={props.name}
        />
    );
};
